// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import NProgress from 'vue-nprogress'
import router from './router'
import Buefy from 'buefy'
import _ from 'lodash'
import Utils from './libs/utils'
import VueNativeSock from 'vue-native-websocket'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import VueAgile from 'vue-agile'
import store from './store'

// it fucks up buefy customization see https://github.com/buefy/buefy/issues/287
// import 'buefy/lib/buefy.css'

const coinName = 'dbt'

Vue.prototype.$coinName = coinName
Vue.prototype.$CoinName = coinName.toUpperCase() // _.startCase(coinName)
Vue.prototype.$COINNAME = coinName.toUpperCase()

// host
// Vue.prototype.$host = 'http://localhost:8088'

// axios
Vue.use(VueAxios, axios)

// websocket
const debug = process.env.NODE_ENV !== 'production'
let WS_HOST = 'wss://' + window.location.host + '/ws'
if (debug) {
  WS_HOST = 'ws://localhost:19351/ws'
  // WS_HOST = 'ws://150.109.44.202/ws'
}
Vue.use(VueNativeSock, WS_HOST, { store })
store.$socket = Vue.prototype.$socket

// lodash
Vue.prototype.$_ = _

// utils
Vue.prototype.$utils = Utils

// buefy

Vue.use(Buefy, {
  defaultIconPack: 'fa'
})

// nprogress

Vue.use(NProgress)

const nprogress = new NProgress({ parent: '.nprogress-container' })

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  store.dispatch('setLoading', true)
  nprogress.start()
  return config
}, function (error) {
  // Do something with request error
  store.dispatch('setLoading', false)
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  store.dispatch('setLoading', false)
  nprogress.done()
  return response
}, function (error) {
  // Do something with response error
  store.dispatch('setLoading', false)
  return Promise.reject(error)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
// i18n
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zhs',
  messages: {
    'en': require('./i18n/en.json'),
    'zhs': require('./i18n/zhs.json'),
    'ja': require('./i18n/ja.json')
  }
})

// vue-agile
Vue.use(VueAgile)

new Vue({
  el: '#app',
  router,
  store,
  nprogress,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js